export const renderTipoAccion = (tipo: number) => {
    switch (tipo) {
        case 0: return "Adición";
        case 1: return "Modificación";
        case 2: return "Eliminación";
    }
}

export const renderClavePrimaria = (clavePrimaria: { [key: string]: any }) => {
    const res: string[] = [];
    for (const [key, value] of Object.entries(clavePrimaria)) {
        res.push(`${key}:${value}`)
    }
    return res.join(", ");
}

export const renderColumnasAfectadas = (columnasAfectadas: string[]) => {
    return columnasAfectadas.join(", ");
}